import Detalhes from './Detalhes'
import Editar from './Editar'
import Importar from './Importar'
import Listar from './Listar'
import Novo from './Novo'
import Index from './index'

const route = {
  path: '/equipamentos',
  name: 'equipamentos',
  component: Index,
  children: [
    {
      path: 'importar',
      name: 'equipamentos-importar',
      component: Importar,
      props: true
    },
    { path: 'listar', name: 'equipamentos-listar', component: Listar, props: { titulo: 'Listar', status: null } },
    { path: 'listar-cadastrados', name: 'equipamentos-listar-cadastrados', component: Listar, props: { titulo: 'Listar Ativação', status: 1 } },
    { path: 'listar-disponivel-ponto-apoio', name: 'equipamentos-listar-disponivel-ponto-apoio', component: Listar, props: { titulo: 'Listar Disponível Ponto Apoio', status: 3 } },
    { path: 'listar-em-utilizacao', name: 'equipamentos-listar-em-utilizacao', component: Listar, props: { titulo: 'Listar Em Utilização', status: 4 } },
    { path: 'listar-em-transito', name: 'equipamentos-listar-em-transito', component: Listar, props: { titulo: 'Listar Em Trânsito', status: 2 } },
    { path: 'listar-inativos', name: 'equipamentos-listar-inativos', component: Listar, props: { titulo: 'Listar Inativos', status: 5 } },
    { path: 'listar-garantia', name: 'equipamentos-listar-garantia', component: Listar, props: { titulo: 'Listar Garantia', status: 6 } },
    { path: 'listar-perda', name: 'equipamentos-listar-perda', component: Listar, props: { titulo: 'Listar Perda/Roubo', status: 7 } },
    { path: 'listar-manutencao', name: 'equipamentos-listar-manutencao', component: Listar, props: { titulo: 'Listar Manutenção', status: 8 } },
    { path: 'novo', name: 'equipamentos-novo', component: Novo },
    { path: ':id', name: 'equipamentos-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'equipamentos-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/equipamentos/routes.js